import React, { Fragment } from 'react';
import UploadIcon from '@material-ui/icons/CloudUploadTwoTone';
import { Button } from '@material-ui/core';

/* eslint react/prop-types: 0 */
const ImmediateFileUploaderCustomInput = ({
  className,
  style,
  getFilesFromEvent,
  accept,
  multiple,
  disabled,
  withFilesContent,
  onFiles,
  files,
}) => (
  <Fragment>
    {files.length > 0 ? withFilesContent : null}
    <Button style={{ margin: 8 }} variant="outlined" color="primary" fullWidth component="label">
      <UploadIcon style={{ marginRight: 4 }} />
      Wybierz plik
      <input
        className={className}
        style={style}
        type="file"
        accept={accept}
        multiple={multiple}
        disabled={disabled}
        onChange={async e => {
          const target = e.target;
          const chosenFiles = await getFilesFromEvent(e);
          onFiles(chosenFiles);
          target.value = null;
        }}
      />
    </Button>
  </Fragment>
);

export default ImmediateFileUploaderCustomInput;



// WEBPACK FOOTER //
// ./src/components/common/ImmediateFileUploaderCustomInput.js